export const environment = {
    production: true,
    apiEndPoint: 'https://dev-api.greatr.com.au/v1/web'
};